import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl, sharedValidators } from "../../lib/shared/validators";

export const branchStatus = v.union(v.literal("active"), v.literal("inactive"));
export const validatorBranch = v.object({
  name: v.string(),
  code: v.string(),
  correlativeCode: v.optional(v.string()),
  description: v.optional(v.string()),
  legalName: v.optional(v.string()),
  taxId: v.optional(v.string()),
  email: v.optional(v.string()),
  phone: v.optional(v.string()),
  address: v.optional(v.string()),
  city: v.optional(v.string()),
  country: v.optional(v.string()),
  website: v.optional(v.string()),
  logoId: v.optional(v.id("_storage")),
  companyId: v.optional(v.id("companies")),
  // Configuracion predeterminada de la sucursal
  defaultTaxRate: v.optional(v.number()),
  defaultProfitMargin: v.optional(v.number()),
  defaultCurrency: v.optional(v.string()),
  internalControl: internalControl,
});

export const branches = defineTable(validatorBranch)
  .index("by_code", ["code"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ]);
